<p-card class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title>Payment Methods</ng-template>
  <div *ngIf="!payment_methods() || payment_methods()!.length === 0">
    No payment methods found
  </div>
  <div *ngIf="payment_methods() && payment_methods()!.length > 0">
    <table>
      <thead>
        <tr>
          <th>Card Type</th>
          <th>Card Last 4</th>
          <th>Expiry Date</th>
          <th>Default</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of payment_methods()">
          <td>{{ item.card_brand }}</td>
          <td>{{ item.last4 }}</td>
          <td>{{ item.card_expiry_month }}/{{ item.card_expiry_year }}</td>
          <td>{{ item.isDefault | boolToText }}</td>
          <td>
            <p-button
              (click)="menuClicked(item); menu.toggle($event)"
              icon="pi pi-ellipsis-v" />
          </td>
        </tr>
      </tbody>
    </table>
    <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
  </div>
</p-card>
